<template>
  
</template>

<script>
export default {
    data(){
        return{

        }
    },
    created(){
        location.href = 'weixin://dl/business/?t=CdOe99dcv7a'
    }
}
</script>

<style>

</style>